module.exports = __webpack_public_path__ + "img/mad.65a522cc.svg";